

<tgrid-layer-header [layer]="this" [additionIcons]="iconConfig()">

  <div ngProjectAs="filters">
    <form [formGroup]="filterGroup">
      <mat-form-field appearance="outline">
        <mat-label>Restoration Percent</mat-label>
        <mat-select formControlName="percent">
          @for (entry of restorationPercents; track entry) {
            <mat-option [value]="entry">{{ entry.percentValue }}%</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Min Restoration Time (Hours)</mat-label>
        <mat-select formControlName="minDuration">
          <mat-option [value]="12">12</mat-option>
          <mat-option [value]="24">24</mat-option>
          <mat-option [value]="48">48</mat-option>
        </mat-select>
      </mat-form-field>
    </form>

    <p class="info-text">Viewing outage events that took over {{ filterGroup.controls.minDuration.value }} hours to
      reach
    {{ filterGroup.controls.percent.value.percentValue }}% restoration</p>

  </div>

  <div class="legend">
    @for (item of legendItems(); track item.label) {
      <div class="legend-line">
        <div class="color-dot" [style.background-color]="item.color"></div>
        <span>{{ item.label }}</span>
      </div>
    }
  </div>

</tgrid-layer-header>
